export default __webpack_public_path__ + "static/media/facebook_b.925de34c.webp";